import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function FeatureWarning(props) {
    const { t, i18n } = useTranslation();
  return (
    <>
      <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
        <MDBIcon
          fas
          icon="exclamation-triangle"
          className="me-3 fs-5 mt-1"
          color="warning"
        />
        <div>{props.warningMessage}</div>
      </div>
      <MDBModalFooter>
        <MDBBtn
          onClick={(e) => props.onOk()}
          //   onClick={(e) => {
          //     e.preventDefault();
          //     setValue("fax_enable", false, {
          //       shouldDirty: true,
          //     });
          //     faxWarningToggle();
          //   }}
        >
          {t("ok")}
        </MDBBtn>
      </MDBModalFooter>
    </>
  );
}

export default FeatureWarning;
